import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import SAInputLabel from "../../common/input/SAInputLabel";
import SAInputComponent from "../../common/input/SAInputComponent";
import SADatePicker from "../../common/input/SADatePicker";
import Constants from "../../../services/Constants";
import moment from 'moment';

class ManualRentalBookingModal extends React.Component {

  constructor(props) {
    super(props);
    const {rentingCustomer} = this.props.rentalDetails;
    this.state = {
      errors: {},
      formData: {
        ...rentingCustomer
      },
    }
  }

  // componentWillReceiveProps = (nextProps)=>{
  //   if (nextProps.rentalDetails){
  //     const {rentingCustomer} = nextProps.rentalDetails
  //     this.setState({rentingCustomer});
  //   }
  // }

  handleDateChangeValue = (name, value) => {
    const formattedDate = value && moment(value).format(Constants.DATE_FORMAT_API);
    const {formData} = this.state;
    formData[name] = formattedDate;
    this.setState({formData});
  };
  handleChangeValue = (name, value) => {
    const {formData} = this.state;
    formData[name] = value;
    this.setState({formData});
  };

  handleChangeEvent = (event) => {
    const target = event.target;
    const value = (target.type === 'checkbox') ? target.checked : target.value;
    const name = target.name;
    this.handleChangeValue(name, value);
  };

  isDisabledDay = (currentDate) => {
    const {rentalAvailability, rentalVehicle} = this.props.rentalDetails;
    const selectedDay = currentDate.format(Constants.DATE_FORMAT_API);
    if (!rentalAvailability[selectedDay]) {
      return true;
    }
    const isBooked = rentalAvailability[selectedDay].dayStatus === 'CLOSED' || ['NOT_AVAILABLE', 'RENTED', 'ASSIGNED'].includes(rentalAvailability[selectedDay].rentalStatus);
    return isBooked || (rentalVehicle.deactivationDate && currentDate.isAfter(moment(rentalVehicle.deactivationDate)));
  }

  onDelete = () => {
    const {rentalDetails} = this.props;
    this.props.onDelete(rentalDetails.id);
  }
  onSave = () => {
    const {formData} = this.state;

    const errors = {};

    if (!formData.firstName) {
      errors['firstName'] = {message: 'error.not.null'};
    }

    if (!formData.lastName) {
      errors['lastName'] = {message: 'error.not.null'};
    }
    if (!formData.from) {
      errors['from'] = {message: 'error.not.null'};
    }
    if (!formData.to) {
      errors['to'] = {message: 'error.not.null'};
    }
    if (moment(formData.from).isAfter(formData.to, 'day')) {
      errors['to'] = {message: 'error.greater.or.equal', args: moment(formData.from).format(Constants.DATE_FORMAT_DISPLAY)};
    }

    formData.rentalVehicleId = this.props.rentalDetails.rentalVehicle.vehicleId;
    formData.rentalDetailsId = this.props.rentalDetails.id;

    this.setState({
      errors: errors,
      confirmLoading: false,
    });

    if (Object.keys(errors).length === 0) {
      this.props.onSave({...formData});
    }

  }

  render() {
    const {intl: {formatMessage}, rentalDetails, backendErrors, onModalClose, visible} = this.props;
    const {formData, errors} = this.state;

    const formErrors = (backendErrors && backendErrors.content) ? backendErrors.content : errors;

    if (!formData) {
      return null;
    }

    return (
      <Modal title={formatMessage({id: 'section.car-park.modal.title'})} visible={visible} onCancel={onModalClose} footer={
        <div>
          {rentalDetails.id && <button className="ant-btn" key="delete" onClick={this.onDelete}>{formatMessage({id: 'action.delete'})}</button>}
          <button className="ant-btn ant-btn-primary" key="save" onClick={this.onSave}>{formatMessage({id: 'action.save'})}</button>
        </div>
      }>
        <h3 className="box__subtitle">{formatMessage({id: 'customer.details.title'})}</h3>

        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.firstname'} name={"firstName"} value={formData.firstName} error={formErrors['firstName']} onChange={this.handleChangeEvent}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.lastname'} name={"lastName"} value={formData.lastName} error={formErrors['lastName']} onChange={this.handleChangeEvent}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'summary.phone'} name={"phone"} value={formData.phone} error={formErrors['phone']} onChange={this.handleChangeEvent}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent label={formatMessage({id: 'placeholder.startDate'})}>
              <SADatePicker disabledDate={this.isDisabledDay} onChange={(value) => this.handleDateChangeValue('from', value)} value={formData.from} error={formErrors['from']}/>
            </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent label={formatMessage({id: 'placeholder.endDate'})}>
              <SADatePicker disabledDate={this.isDisabledDay} onChange={(value) => this.handleDateChangeValue('to', value)} value={formData.to} error={formErrors['to']}/>
            </SAInputComponent>
          </div>
        </div>
      </Modal>
    )
  }
}

export default injectIntl(ManualRentalBookingModal);
